import { React } from 'react'
import { Col } from "react-bootstrap";

export const CardsProduct = ({ title, description, imgUrl }) => {
  return (
    <Col size={12} sm={6} md={4}>
      <div className="product-imgbx">
        <img src={ imgUrl } alt={ title } loading="lazy" className='img-product' />
        <div className="product-txtx">
          <h4>{title}</h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  )
}

